
export const quizData = () => {
    return fetch('https://openapi.programming-hero.com/api/quiz');
}